/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leaderboard_Pr_Type_CustomInputs */

const fr_leaderboard_pr_type_custom = /** @type {(inputs: Leaderboard_Pr_Type_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personnalisé`)
};

/**

* @param {Leaderboard_Pr_Type_CustomInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const leaderboard_pr_type_custom = /** @type {((inputs?: Leaderboard_Pr_Type_CustomInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leaderboard_Pr_Type_CustomInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_leaderboard_pr_type_custom(inputs)
});